export const strategyOptions = [
  {
    key: 'WEBSITE',
    value: 'Website, E-commerce, Landing pages',
    text: 'Website, E-commerce, Landing pages',
    tooltip: `
    <b>Hotsite:</b> Além do site da empresa, o hotsite é um site paralelo desenvolvido para uma divulgação específica.<br/>
    <b>Landing Page:</b> Página que possui os elementos voltados à captação das informações do 
      visitante por meio de inscrições em conteúdos ou produtos/serviços do seu interesse.<br/>
    <b>E-commerce:</b> Site que permite vender pela internet produtos ou serviços. 
      Também conhecido como loja virtual ou loja online.
    ` },
  {
    key: 'SOCIAL_MEDIA',
    value: 'Redes sociais',
    text: 'Redes sociais',
    tooltip: 'Selecione caso sua empresa trabalhe com mídias sociais como: Facebook, Instagram, Linkedin, etc..',
  },
  {
    key: 'ADS',
    value: 'Mídia paga (Anúncios no Google e Redes Sociais)',
    text: 'Mídia paga (Anúncios no Google e Redes Sociais)',
    tooltip: '<b>Mídia paga:</b> Investimento em anúncios na internet como Google Ads, Facebook Ads e Instragam Ads.',
  },
  {
    key: 'INBOUND',
    value: 'Inbound marketing (Prospecção passiva)',
    text: 'Inbound marketing (Prospecção passiva)',
    tooltip: `<b>Inbound:</b> Conjunto de estratégias de marketing e vendas 
    que visam atrair e converter clientes utilizando conteúdo relevante e automações.<br/>`,
  },
  {
    key: 'OUTBOUND',
    value: 'Outbound marketing (Prospecção ativa)',
    text: 'Outbound marketing (Prospecção ativa)',
    tooltip: `<b>Outbound:</b> Também conhecido como marketing tradicional e prospecção ativa, 
    tem como objetivo buscar clientes para o seu negócio antes de o prospect fazer qualquer interação com a sua empresa.`,
  },
  {
    key: 'GROWTH_BI',
    value: 'Growth, BI ou Big Data',
    text: 'Growth, BI ou Big Data',
    tooltip: `
    <b>Growth:</b> Estratégias de crescimento que visam testes contínuos para melhor aproveitamento dos recursos de marketing e vendas.<br/>
    <b>BI:</b> (Business Intelligence). Inteligência de negócios 
      refere-se ao processo de coleta, organização, análise, compartilhamento e monitoramento de 
      informações que oferecem suporte a gestão de negócios.<br/>
    <b>Big Data:</b> Área do conhecimento que estuda como tratar, analisar e obter <br/>
      informações a partir de conjuntos de dados grandes demais para serem analisados por sistemas tradicionais.`,
  },
  {
    key: 'CRM',
    value: 'Ferramentas de Marketing e Vendas',
    text: 'Ferramentas de Marketing e Vendas',
    tooltip: `
    Alguns exemplos de Ferramentas são: <br/>
    <b>Automação de Marketing: </b>Ferramenta para automatizar ações e processos de marketing, 
      reduzir trabalhos manuais e aumentar a eficiência das ações.<br/>
    <b>Telefonia digital:</b>Possibilita a discagem para os seus contatos através do uso da internet.<br/>
    <b>Chatbot:</b> Automatização do relacionamento com contatos através de conversas por chat no site, Facebook Messenger ou Whatsapp.<br/>
    <b>CRM: </b>(Customer Relationship Management) Gestão de Relacionamento com o cliente.<br/>
    <b>ERP:</b> (Enterprise Resource Planning) Sistema de gestão que permite acesso fácil, integrado e confiável aos dados de uma empresa.<br/>
` },
  {
    key: 'EVENTS',
    value: 'Eventos online ou presenciais',
    text: 'Eventos online ou presenciais',
    tooltip: '',
  },
  {
    key: 'ASSOCIATIONS',
    value: 'Associações Empresariais',
    text: 'Associações Empresariais',
    tooltip: '',
  },
  {
    key: 'INDICATIONS',
    value: 'Indicações de outros clientes',
    text: 'Indicações de outros clientes',
    tooltip: 'Indicações de outros clientes e boca-a-boca.',
  },
  {
    key: 'OTHERS',
    value: 'Outras',
    text: 'Outras',
    tooltip: '',
  },
  {
    key: 'NONE',
    value: 'Nenhuma das alternativas anteriores',
    text: 'Nenhuma das alternativas anteriores',
    tooltip: '',
  },
];

export const companyMomentOptions = [
  {
    key: 'IDEA',
    text: 'Só tenho a ideia.',
    value: 'Só tenho a ideia.',
    tooltip: '',
  },
  {
    key: 'OPENING',
    text: 'Estou abrindo agora a minha empresa e preciso de ajuda para fazer as minhas primeiras vendas',
    value: 'Estou abrindo agora a minha empresa e preciso de ajuda para fazer as minhas primeiras vendas',
    tooltip: '',
  },
  {
    key: 'ALREADY_SELLING',
    text: 'Tenho empresa ativa e já estou vendendo meus produtos/serviços',
    value: 'Tenho empresa ativa e já estou vendendo meus produtos/serviços',
    tooltip: '',
  },
];

export const projectTypeOptions = [
  {
    key: 'NEED_HELP',
    value: 'Não sei o que preciso para conseguir vender mais, preciso da ajuda de um especialista.',
    text: 'Não sei o que preciso para conseguir vender mais, preciso da ajuda de um especialista.',
    tooltip: '',
  },
  {
    key: 'KNOW_WHAT_NEEDS',
    value: 'Já sei o que preciso e estou em busca de serviços específicos.',
    text: 'Já sei o que preciso e estou em busca de serviços específicos.',
    tooltip: '',
  },
];

export const slaOptions = [
  {
    value: 'NO_ONE',
    text: 'Não existe e por isso, pouco planejamos e discutimos sobre marketing e vendas.',
    tooltip: '',
  },
  {
    value: 'NO_TWO',
    text: 'Não, as áreas atuam de forma independente e por isso, conversam menos do que deveriam.',
    tooltip: '',
  },
  {
    value: 'YES_BUT',
    text: 'Existe algum acordo, mas não é formalizado e por isso, as vezes existe conflito entre as áreas.',
    tooltip: '',
  },
  {
    value: 'YES',
    text: 'Sim, marketing e vendas tem clareza sobre as suas responsabilidades para que a empresa cresça.',
    tooltip: '',
  },
];

export const rolesOptions = [
  {
    value: 'Sócio',
    text: 'Sócio',
    tooltip: '',
  },
  {
    value: 'Diretor / C-level',
    text: 'Diretor / C-level',
    tooltip: '',
  },
  {
    value: 'Gerente / Coordenador',
    text: 'Gerente / Coordenador',
    tooltip: '',
  },
  {
    value: 'Analista / Assistente',
    text: 'Analista / Assistente',
    tooltip: '',
  },
  {
    value: 'Estudante / Estagiário',
    text: 'Estudante / Estagiário',
    tooltip: '',
  },
  {
    value: 'Outro',
    text: 'Outro',
    tooltip: '',
  },

];

export const clientTypeOptions = [
  {
    value: 'Vendemos para o consumidor final - B2C',
    text: 'Vendemos para o consumidor final - B2C',
    tooltip: 'B2C ou Business to Customer: empresas que vendem direto para o consumidor final',
  },
  {
    value: 'Vendemos para empresas - B2B',
    text: 'Vendemos para empresas - B2B',
    tooltip: 'B2B ou Business to Business: empresas que vendem para outras empresas',
  },
  {
    value: 'Vendemos para o governo - B2G',
    text: 'Vendemos para o governo - B2G',
    tooltip: 'B2G ou Business to Government: empresas que vendem para o governo',
  },
  {
    value: 'Não sei',
    text: 'Não sei',
    tooltip: '',
  },

];

export const segmentOptions = [
  {
    value: 'Agências de Marketing e Vendas', text: 'Agências de Marketing e Vendas',
  },
  {
    value: 'Agências de Eventos', text: 'Agências de Eventos',
  },
  {
    value: 'Profissionais de Experiência do Cliente', text: 'Profissionais de Experiência do Cliente',
  },
  {
    value: 'Consultores Digitais em Geral', text: 'Consultores Digitais em Geral',
  },
  {
    value: 'Desenvolvedores de Software', text: 'Desenvolvedores de Software',
  },
  {
    value: 'Especialistas em Performance', text: 'Especialistas em Performance',
  },
  {
    value: 'Freelancers Digitais', text: 'Freelancers Digitais',
  },
];

export const productProjectOptions = [
  {
    value: 'agencies_marketing',
    text: 'Agências de Marketing e Publicidade',
    tooltip: '',
  },
  {
    value: 'agencies_events',
    text: 'Agências de Eventos Corporativos',
    tooltip: '',
  },
  {
    value: 'sales_coaches',
    text: 'Coach de vendas',
    tooltip: '',
  },
  {
    value: 'consultant_general',
    text: 'Consultores Digitais em geral',
    tooltip: '',
  },
  {
    value: 'software_developers',
    text: 'Desenvolvedores de software',
    tooltip: '',
  },
  {
    value: 'freelancers',
    text: 'Freelancers digitais criativos',
    tooltip: '',
  },
  {
    value: 'profissionals_cs',
    text: 'Profissionais de experiência do cliente',
    tooltip: '',
  },
  {
    value: 'video_producing',
    text: 'Produtoras de vídeo',
    tooltip: '',
  },
  {
    value: 'others',
    text: 'Outros',
    tooltip: '',
  },
];

export const objectiveOptions = [
  {
    value: 'improve_marketing',
    text: 'Melhorar marketing',
    tooltip: '',
  },
  {
    value: 'increase_sales',
    text: 'Aumentar as vendas',
    tooltip: '',
  },
  {
    value: 'improve_customer_experience',
    text: 'Melhorar a experiência dos meus clientes',
    tooltip: '',
  },
  {
    value: 'implement_tool',
    text: 'Implantar novas ferramentas',
    tooltip: '',
  },
  {
    value: 'hire_people',
    text: 'Ajuda em gestão de pessoas',
    tooltip: '',
  },
  {
    value: 'digital_transformation',
    text: 'Ajuda com Transformação Digital',
    tooltip: '',
  },
  {
    value: 'generate_leads',
    text: 'Gerar novas oportunidades para venda',
    tooltip: '',
  },
  {
    value: 'branding',
    text: 'Melhorar branding e posicionamento',
    tooltip: '<b>Branding e Posicionamento:</b> Conjunto de ações alinhadas ao posicionamento, propósito e valores da marca.',
  },
  {
    value: 'marketing_sales_plan',
    text: 'Estruturar áreas de Marketing e/ou Vendas',
    tooltip: '',
  },
  {
    value: 'paid_media',
    text: 'Trabalhar com anúncios digitais',
    tooltip: '<b>Mídia paga:</b> Investimento em anúncios na internet como Google Ads, Facebook Ads e Instragam Ads.',
  },
  // {
  //   value: 'website',
  //   text: 'Fazer ou atualizar Website, E-commerce e/ou Landing pages',
  //   tooltip: `<b>Landing Page:</b> Página que possui os elementos voltados à captação das informações do visitante por
  //     meio de inscrições em conteúdos ou produtos/serviços do seu interesse.<br/>
  //   <b>E-commerce:</b> Site que permite vender pela internet produtos ou serviços. Também conhecido como loja virtual ou loja online.
  // `,
  // },
  { value: 'social_media', text: 'Melhorar presença nas mídias sociais', tooltip: 'Instagram, Facebook, LinkedIn, etc.' },
  { value: 'none', text: 'Nenhuma das alternativas anteriores.', tooltip: '' },
];

export const launchOptions = [
  {
    value: 'branding',
    text: 'Branding e Posicionamento da minha marca no mercado',
    tooltip: '<b>Branding e Posicionamento:</b> Conjunto de ações alinhadas ao posicionamento, propósito e valores da marca.',
  },
  { value: 'actions_impact', text: 'Estar presente em ações com grande impacto de pessoas e empresas', tooltip: '' },
  { value: 'marketing_plan', text: 'Planejamento de Marketing', tooltip: '' },
  { value: 'sales_plan', text: 'Planejamento Comercial', tooltip: '' },
  {
    value: 'website',
    text: 'Fazer ou atualizar Website, E-commerce, Hotsite e/ou Landing pages',
    tooltip: `<b>Hotsite:</b> Além do site da empresa, o hotsite é um site paralelo desenvolvido para uma divulgação específica.<br/>
      <b>Landing Page:</b> Página que possui os elementos voltados à captação das informações do 
        visitante por meio de inscrições em conteúdos ou produtos/serviços do seu interesse.<br/>
      <b>E-commerce:</b> Site que permite vender pela internet produtos ou serviços. Também conhecido como loja virtual ou loja online.
  `,
  },
  { value: 'social_media', text: 'Melhorar a nossa presença nas Redes Sociais', tooltip: '(Instagram, Facebook, LinkedIn, etc.)' },
  {
    value: 'paid_media',
    text: 'Trabalhar com mídia paga',
    tooltip: '<b>Mídia paga:</b> Investimento em anúncios na internet como Google Ads, Facebook Ads e Instragam Ads.',
  },
  { value: 'performance', text: 'Performance para gerar mais leads/contatos.', tooltip: '' },
  { value: 'none', text: 'Nenhuma das alternativas anteriores.', tooltip: '' },
];

export const numberEmployeeSuggestions = [
  { value: '0', text: 'Nenhum' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5' },
  { value: '10', text: '10' },
  { value: '20', text: '20' },
  { value: '50', text: '50' },
];

export const numberAllEmployeeSuggestions = [
  { value: '0', text: 'Nenhum' },
  { value: '1', text: '1' },
  { value: '5', text: '5' },
  { value: '10', text: '10' },
  { value: '25', text: '25' },
  { value: '50', text: '50' },
  { value: '100', text: '100' },
  { value: '250', text: '250' },
  { value: '1000', text: '1000' },
];

export const numberAdSuggestions = [
  { value: 0, label: 'Zero', text: 'Zero' },
  { value: 100, label: 'R$ 100,00', text: '100' },
  { value: 500, label: 'R$ 500,00', text: '500' },
  { value: 1000, label: 'R$ 1.000,00', text: '1.000' },
  { value: 5000, label: 'R$ 5.000,00', text: '5.000' },
  { value: 10000, label: 'R$ 10.000,00', text: '10.000' },
  { value: 20000, label: 'R$ 20.000,00', text: '20.000' },
  { value: 50000, label: 'R$ 50.000,00', text: '50.000' },
];

export const projectDeadlineSuggestions = [
  { value: 7, text: '7 dias' },
  { value: 15, text: '15 dias' },
  { value: 30, text: '30 dias' },
  { value: 60, text: '60 dias' },
];
